import { Screen, FontSize } from 'styles';
import styled, { css } from "styled-components";

const SmallHeaderTitleStyle = css`
  display: block;
  font-size: ${FontSize.L};
  text-align: center
`;

export const StyledElementHeaderTitle = styled.h2`
  display: inline-block;
  font-size: ${FontSize.XXL};
  letter-spacing: 5.2px;
  
   ${Screen.small(SmallHeaderTitleStyle)}
`;


// WEBPACK FOOTER //
// ./src/utils/styledElements/headerTitle/headerTitle.style.js